import { render, staticRenderFns } from "./addBlogCategory.vue?vue&type=template&id=f2bb91d0&"
import script from "./addBlogCategory.vue?vue&type=script&lang=js&"
export * from "./addBlogCategory.vue?vue&type=script&lang=js&"
import style0 from "./addBlogCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports